<template>
  <div class="mobile-menu _px-4 _py-6">
    <AppSearch></AppSearch>
    <div class="menu _mt-6 _pb-6 _mb-6">
      <div
        v-for="(link, ind) in menu"
        :key="ind"
        v-html="link.txt"
        class="_fs-16 d-block _lh-24 _tc-dark _mb-4"
        @click="dataLayerPush(link.txt, link.to)"
      ></div>
    </div>
    <div class="d-flex align-center">
      <LocaleSwitcher class="_mr-auto" />
      <AppBtn v-if="false" @click.native="helpButtonClick()" class="">
        <span class="_fs-16 _lh-24 _py-2 _px-4">{{
          $t('interface.help')
        }}</span>
      </AppBtn>
    </div>
  </div>
</template>

<script>
import AppBtn from '../../components/UI/buttons/AppBtn.vue'
import AppSearch from './AppSearch.vue'
import LocaleSwitcher from './LocaleSwitcher.vue'
export default {
  components: { AppSearch, LocaleSwitcher, AppBtn },
  name: 'AppMobileMenu',
  computed: {
    menu() {
      if (this.Trans.currentLocale !== 'ru') {
        return [
          {
            txt: this.$t('interface.menu.onboarding'),
            to: this.helpers.buildRoute({ name: 'Onboarding' }),
          },
          {
            txt: this.$t('interface.menu.hngrow'),
            to: this.helpers.buildRoute({ name: 'HNGrow' }),
          },
          {
            txt: this.$t('interface.menu.academy'),
            to: this.helpers.buildRoute({ name: 'SuccessAcademy' }),
          },
          {
            txt: this.$t('interface.menu.intensives'),
            to: this.helpers.buildRoute({ name: 'Intensives' }),
          },
          {
            txt: this.$t('interface.menu.trainings'),
            to: this.helpers.buildRoute({ name: 'Trainings' }),
          },
          {
            txt: this.$t('interface.menu.system'),
            to: this.helpers.buildRoute({ name: 'System' }),
          },
          {
            txt: this.$t('interface.menu.network_security'),
            to: this.helpers.buildRoute({ name: 'NetworkSecurity' }),
          },
          {
            txt: this.$t('interface.menu.success_wall'),
            to: this.helpers.buildRoute({ name: 'SuccessLadder' }),
          },
          {
            txt: this.$t('interface.menu.useful_resources'),
            to: this.helpers.buildRoute({ name: 'UsefulResources' }),
          },
          // {
          //   txt: `Лидерборд <svg
          //       style="transform: translateY(2px)"
          //       class="_ml-2 d-inline-block"
          //       width="23"
          //       height="18"
          //       viewBox="0 0 23 18"
          //       fill="none"
          //       xmlns="http://www.w3.org/2000/svg"
          //     >
          //       <path
          //         d="M1.20327 6.1679L4.39936 16.6693C4.45249 16.8439 4.6491 16.9302 4.81604 16.8565C10.4364 14.3753 15.8561 15.7174 18.1884 16.8415C18.3547 16.9216 18.555 16.8419 18.6156 16.6675L22.2576 6.19683C22.346 5.94261 22.0809 5.70957 21.8401 5.82994L16.7369 8.38156C16.6016 8.44922 16.437 8.40553 16.3531 8.27964L11.763 1.39444C11.6408 1.2112 11.3694 1.21765 11.2561 1.4065L7.14293 8.26178C7.06228 8.3962 6.89173 8.44587 6.75152 8.37576L1.62444 5.81222C1.38877 5.69439 1.12656 5.91583 1.20327 6.1679Z"
          //         fill="#FED141"
          //         stroke="#FED141"
          //       />
          //     </svg>`,
          //   to: this.helpers.buildRoute({ name: 'Leaderboard' }),
          // },
        ]
      }
      return [
        {
          txt: this.$t('interface.menu.onboarding'),
          to: this.helpers.buildRoute({ name: 'Onboarding' }),
        },
        {
          txt: this.$t('interface.menu.hngrow'),
          to: this.helpers.buildRoute({ name: 'HNGrow' }),
        },
        {
          txt: this.$t('interface.menu.academy'),
          to: this.helpers.buildRoute({ name: 'SuccessAcademy' }),
        },
        {
          txt: this.$t('interface.menu.intensives'),
          to: this.helpers.buildRoute({ name: 'Intensives' }),
        },
        // {
        //   txt: this.$t('interface.menu.webinars'),
        //   to: this.helpers.buildRoute({ name: 'Webinars' }),
        // },
        {
          txt: this.$t('interface.menu.trainings'),
          to: this.helpers.buildRoute({ name: 'Trainings' }),
        },
        {
          txt: this.$t('interface.menu.system'),
          to: this.helpers.buildRoute({ name: 'System' }),
        },
        {
          txt: this.$t('interface.menu.network_security'),
          to: this.helpers.buildRoute({ name: 'NetworkSecurity' }),
        },
        {
          txt: this.$t('interface.menu.success_wall'),
          to: this.helpers.buildRoute({ name: 'SuccessLadder' }),
        },
        {
          txt: this.$t('interface.menu.useful_resources'),
          to: this.helpers.buildRoute({ name: 'UsefulResources' }),
        },
        // {
        //   txt: `Лидерборд <svg
        //       style="transform: translateY(2px)"
        //       class="_ml-2 d-inline-block"
        //       width="23"
        //       height="18"
        //       viewBox="0 0 23 18"
        //       fill="none"
        //       xmlns="http://www.w3.org/2000/svg"
        //     >
        //       <path
        //         d="M1.20327 6.1679L4.39936 16.6693C4.45249 16.8439 4.6491 16.9302 4.81604 16.8565C10.4364 14.3753 15.8561 15.7174 18.1884 16.8415C18.3547 16.9216 18.555 16.8419 18.6156 16.6675L22.2576 6.19683C22.346 5.94261 22.0809 5.70957 21.8401 5.82994L16.7369 8.38156C16.6016 8.44922 16.437 8.40553 16.3531 8.27964L11.763 1.39444C11.6408 1.2112 11.3694 1.21765 11.2561 1.4065L7.14293 8.26178C7.06228 8.3962 6.89173 8.44587 6.75152 8.37576L1.62444 5.81222C1.38877 5.69439 1.12656 5.91583 1.20327 6.1679Z"
        //         fill="#FED141"
        //         stroke="#FED141"
        //       />
        //     </svg>`,
        //   to: this.helpers.buildRoute({ name: 'Leaderboard' }),
        // },
      ]
    },
  },
  methods: {
    dataLayerPush(txt, path) {
      if (this.$gtm) {
        this.$gtm.push({
          event: 'ev_header_menu',
          param_value: this.helpers.stripHtml(txt),
        })
      }
      if (path && this.$route.name !== path.name) {
        this.$router.push(path)
      }
    },
    helpButtonClick() {
      if (this.$gtm) {
        this.$gtm.push({
          event: 'ev_click_search',
        })
      }
      window.open('https://t.me/+fR3ci9egP2tkZjc6')
    },
  },
}
</script>

<style lang="scss" scoped>
.mobile-menu {
  position: absolute;
  top: 100%;
  left: 0;
  width: 100%;
  height: auto;
  background-color: #fff;
  max-height: calc(100vh - 56px);
  overflow-y: auto;
}

.menu {
  border-bottom: 1px solid #d7dde2;
}

.menu > div {
  cursor: pointer;
}
</style>
<style>
.menu br {
  display: none;
}
</style>
